p<template>
    <ul class="nav navbar-nav">

        <router-link :to="{name: route.name}" role="button" active-class="open" aria-expanded="false" tag="li" class="nav-item" v-for="route in routes" :key="route.meta.label" exact>
            <a class="nav-link" :class="{'hidden': route.meta.noLabel}">
                <span :class="'icon ' + route.meta.icon"></span>
                <span>{{ $t(route.meta.label) }}</span>
            </a>

            <submenu v-if="route.submenu" :items="route.submenu"></submenu>
        </router-link>
    </ul>
</template>

<script>
    import { getMenuItems, canAccess } from "../../../router/index"
    import auth from "../../../utils/auth"
    import submenu from "./submenu.vue"

    export default {
        components: {
            submenu
        },
        computed: {
            routes: {
                get: function(){
                    return getMenuItems().filter(route => route.meta.inMainmenu)
                }
            }
        },
        methods: {
            handleLogout() {
                auth.logout();
            }
        }
    }

</script>
<style>
    .hidden {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/menus/mainmenu.vue